import { render, staticRenderFns } from "./ComplaintPage.vue?vue&type=template&id=373a0165&scoped=true&"
import script from "./ComplaintPage.vue?vue&type=script&lang=js&"
export * from "./ComplaintPage.vue?vue&type=script&lang=js&"
import style0 from "./ComplaintPage.vue?vue&type=style&index=0&id=373a0165&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "373a0165",
  null
  
)

export default component.exports